export enum Frequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
}

export interface IFrequency {
  label: string;
  value: Frequency;
}

export const Frequencies: IFrequency[] = [
  { label: 'Daily', value: Frequency.DAILY },
  { label: 'Weekly', value: Frequency.WEEKLY },
];

export const getFrequencyNameFromKey = (key: Frequency) => {
  return Frequencies.find((f) => f.value === key)?.label ?? '';
};
